<template>
  <tr style="padding: 0px;" id="myrow" >
    <td style="text-align: center;padding: 0px;"> {{ row.idx + 1}} </td>

    <td  style="padding: 0px;width: 60px;">
      <input ref="el_fabcode" type="number" class="form-control" v-model="row.fabric_id" @keyup.enter="loadFabric(row.fabric_id)" />
    </td>
    <td style="padding: 0px;">
      <button class="btn btn-outline-success" @click="loadFabric(row.fabric_id)" tabindex="-1" >Find</button>
    </td>

    <td style="padding: 0px;text-align: right;width: 100px;">
      <input ref="el_qty" type="number" class="form-control text-right" v-if="row" v-model="row.used_qty" @change="showmsg(3)" />
    </td>

    <td style="padding: 0px;">
      {{row.fabric.quality.name}}
    </td>
    <td style="padding: 0px;">
      {{row.fabric.color.name}}
    </td>


    <td style="padding: 0px;text-align: right">
      <button name="btnRemoveRow"   type="button" class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow" @click="removeRow(index)" tabindex="-1" ><i class="icon-eraser"></i></button>
    </td>

  </tr>
</template>

<script>
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'

  export default {
    name: 'RollingDetailRow',
    props: {
      myrow: {
        type: Object,
        default: () => JSON.parse('{"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"used_qty":0,"used_weight":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}}')
      },
      myindex: {
        type: Number,
        default: () => 0
      },
    },
    beforeMount () {
      this.row = this.myrow;
      this.index = this.myindex;
      this.row.idx = this.myindex;
    },
    data () {
      return {
        index: 0,
        row : JSON.parse('{"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"used_qty":0,"used_weight":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}}')
      }
    },
    filters:{
      weightFormat (val){
        return val.toFixed(3);
      }
    },
    methods:{
      removeRow(){
        this.$emit('onRemoveRow', Math.abs(this.row.idx) );
      },
      loadFabric(id){
        if(id < 1) {
          return;
        }

        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.row.idx = self.myindex ;

        block_el('#myrow');

        let url = `${process.env.VUE_APP_ROOT_API}api/knitting/receipt/${id}`;


        fetch(url,requestOptions).then(userService.handleResponse).then(function (resp) {

          if(resp.ok) {

            self.$data.row.fabric_id = resp.data.id;
            self.$data.row.item_id = resp.data.item_id;

            self.$data.row.fabric = resp.data;
            self.$data.row.used_qty = 0;
            self.$data.row.used_weight = 0;

          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error", timer:3000} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error", timer:3000} );
        }).finally(function () {
          $('#myrow').unblock();
        });
      },
      showmsg(colIndex) {
        const self = this;


        switch (colIndex) {
          case 1:
            // this.row.fabric.id
            this.$emit('onrow_change', self.index, colIndex, self.row.fabric_id);
            break;
          case 3:
            this.$emit('onrow_change', self.index, colIndex, parseFloat(self.row.used_qty));
            break;
        }
      },
    }
  }
</script>

<style scoped>
input:focus {
  background: #feff00;
}

textarea:focus {
  background: #feff00;
}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a!important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
